import React from 'react';

import { Text } from 'components/v2/Typography/Text';
import theme from 'kb-shared/theme';

export const PASSWORD_WHITESPACE_RULE = "Passwords can't start or end with a space.";

export const PasswordWhitespaceRule = ({ error }: { error: boolean }) => (
  <Text
    tag="p"
    size="xs"
    fontStyle="lightItalic"
    color={error ? theme.colors.semantic.darkRed : 'auto'}
  >
    {PASSWORD_WHITESPACE_RULE}
  </Text>
);
